import {
  ackSchema,
  labelSchema,
  listLabelsResponseSchema,
  type Ack,
  type CreateLabelRequest,
  type Label,
  type LabelId,
  type UpdateLabelRequest,
} from "@mailflare/shared";

import { apiRequest } from "@/lib/api-client";

export async function listLabels(): Promise<readonly Label[]> {
  return listLabelsResponseSchema.parse(await apiRequest<unknown>("/labels")).labels;
}

export async function createLabel(body: CreateLabelRequest): Promise<Label> {
  return labelSchema.parse(await apiRequest<unknown>("/labels", { method: "POST", body }));
}

export async function updateLabel(labelId: LabelId, body: UpdateLabelRequest): Promise<Label> {
  return labelSchema.parse(
    await apiRequest<unknown>(`/labels/${encodeURIComponent(labelId)}`, { method: "PATCH", body }),
  );
}

export async function deleteLabel(labelId: LabelId): Promise<Ack> {
  return ackSchema.parse(
    await apiRequest<unknown>(`/labels/${encodeURIComponent(labelId)}`, { method: "DELETE" }),
  );
}
